import styled from 'styled-components';

export const BrandsWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;
